import { render } from "./AppSidebar.vue?vue&type=template&id=69e3faa8"
const script = {}

import "./AppSidebar.vue?vue&type=style&index=0&id=69e3faa8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__